import { Order } from './order';

export interface PanelStatsView {
	summary: any;
	tasks: number;
	to_claim: any[];
	to_claim_loose: Order[];
	unclosed: Order[];
}
